<template>
    <v-container>
        <v-data-table
            dense
            multi-sort
            :headers="headers"
            :items="surveys"
            :items-per-page="20"
            :items-per-page-options=[5,20,40]
            :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'mdi-arrow-collapse-left',
                lastIcon: 'mdi-arrow-collapse-right',
                prevIcon: 'mdi-minus',
                nextIcon: 'mdi-plus',
                   'items-per-page-text':'Anzahl Zeilen',
                   'items-per-page-options':[5,20,40]
              }">
        </v-data-table>
        <v-btn @click="exp" v-if="authorized">
            <v-icon left>mdi-cloud-download-outline</v-icon>
            {{ $t('app.export') }}
        </v-btn>
    </v-container>
</template>

<script>
    import {Actions, ActionTypes, Quantities, Roles, VegetationStages} from '../../_helpers'

    export default {
        name: 'Details',
        data: ()=>({
            headers: [
                { text: 'Datum', align: 'start', value: 'date'},
                { text: 'Kunde', value: 'customer' },
                { text: 'Typ', value: 'action' },
                { text: 'Maßnahme', value: 'actionType' },
                { text: 'Neophyt', value: 'neophyteName' },
                { text: 'Stadium', value: 'vegetationStage' },
                { text: 'Fläche', value: 'areaOfPlants' },
                { text: 'Anzahl', value: 'numberOfPlants' }
            ],
        }),
        computed: {
            authorized() {
                let userProfile = this.$store.getters.userProfile

                // Only an authenticated user with SUPERADMIN or ADMIN role is
                // allowed to export data
                return this.$store.getters.isAuthenticated && userProfile
                    && (userProfile.role === Roles.ROLE_1.value || userProfile.role === Roles.ROLE_2.value)
            },
            plants() {
                let list = this.$store.getters.plantList
                //list.push({uuid: 'total', name: this.$t('key.total')})
                return list
            },
            surveys() {
                //replace text for action etc.
                let surveys  = this.$store.getters.filteredSurveyList.map( item => {
                    //console.log(item)
                    item['action'] = this.$options.filters.actionText(item.action)
                    item['actionType'] = this.$options.filters.actionType(item.actionType)
                    item['vegetationStage'] = this.$options.filters.vegetationStageText(item.vegetationStage)
                    if(typeof(this.plants.find(plant => item.neophyte==plant.uuid)) !== "undefined")
                        item["neophyteName"] = this.plants.find(plant => item.neophyte==plant.uuid).name
                    return item
                })
                console.log("surveys")
                return surveys
            }
        },
        methods: {
            exp(){
                console.log("export")
                let data = []

                this.surveys.forEach(surv=> {
                        console.log('filter')
                        surv.action = this.$options.filters.actionText(surv.action)

                        surv.amountUnit = this.$options.filters.quantityText(surv.amountUnit)

                        //console.log(this.plants.find(plant => surv.neophyte==plant.uuid))
                        //surv.neophyte = this.plants.find(plant => surv.neophyte==plant.uuid).name

                        //surv.vegetationStage = this.$options.filters.vegetationStageText(surv.vegetationStage)
                        delete surv.shape
                        delete surv.position
                        data.push(surv)
                    }
                )

                console.log('survey')

                let toCSV = (args) => {
                    let result, ctr, keys, columnDelimiter, lineDelimiter, data;

                    data = args.data || null;
                    if (data == null || !data.length) {
                        return null;
                    }

                    columnDelimiter = args.columnDelimiter || ';';
                    lineDelimiter = args.lineDelimiter || '\n';

                    keys = Object.keys(data[0]);
                    keys = keys.sort()

                    result = '';
                    result += keys.join(columnDelimiter);
                    result += lineDelimiter;

                    data.forEach(function(item) {
                        ctr = 0;
                        keys.forEach(function(key) {
                            if (ctr > 0) result += columnDelimiter;
                            console.log("keys")
                            if(typeof(item[key]) == "undefined")
                                result += '"NA"';
                            else
                                result += '"'+item[key]+'"';
                            ctr++;
                        });
                        result += lineDelimiter;
                    });
                    console.log("export end")
                    return result;
                }

                let csv = toCSV({data:data})
                if (csv == null) return;

                let filename = 'export.csv';


                data = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv);

                let link = document.createElement('a');
                link.setAttribute('href', data);
                link.setAttribute('download', filename);
                link.click();
            },
            filteredSurveys(plantId) {
                // if (plantId === 'total')
                //     return this.surveys

                return this.surveys.filter(({neophyte}) => neophyte === plantId)
            },
            totalCount() {
                let list = this.$store.getters.surveyList.map(item => (item.numberOfPlants) ? item.numberOfPlants : 0)

                // Sum up list
                return this.sumUp(list)
            },
            plantCount(plantId) {
                // if (plantId === 'total')
                //     return this.totalCount()

                let filtered = this.filteredSurveys(plantId)
                    .map(item => (item.numberOfPlants) ? item.numberOfPlants : 0)

                // Sum up filtered items
                return this.sumUp(filtered)
            },
            totalArea() {
                let list = this.$store.getters.surveyList.map(item => (item.areaOfPlants) ? item.areaOfPlants : 0)

                // Sum up list
                return this.sumUp(list)
            },
            plantArea(plantId) {
                // if (plantId === 'total')
                //     return this.totalArea()

                let filtered = this.filteredSurveys(plantId)
                    .map(item => (item.areaOfPlants) ? item.areaOfPlants : 0)

                // Sum up filtered items
                return this.sumUp(filtered)
            },
            sumUp(list) {
                return list.reduce((a, b) => parseInt(a) + parseInt(b), 0)
            }
        },
        filters: {
            actionText(enumValue) {
                let action = Actions.itemByValue(enumValue)
                return action ? action.text : "-"
            },
            actionType(enumValue) {
                let actiontype = ActionTypes.itemByValue(enumValue)
                return actiontype ? actiontype.text : "-"
            },
            quantityText(enumValue) {
                let quantity = Quantities.itemByValue(enumValue)
                return quantity ? quantity.text : "-"
            },
            vegetationStageText(enumValue) {
                let vegetationStage = VegetationStages.itemByValue(enumValue)
                return vegetationStage ? vegetationStage.text : enumValue
            },
            capitalize(value) {
                if (!value)
                    return ''

                value = value.toString()
                return value.charAt(0).toUpperCase() + value.slice(1)
            }
        }
    }
</script>

<style/>
